export const mountableSteps = {
	stepLabel: "Étape",
	addStep: "Ajouter une nouvelle étape",
	removeStep: "Supprimer l'étape",
	cardHeader: {
		titlePlaceholder: "Nom de l'étape",
	},
	fields: {
		title: {
			label: "Titre",
			placeholder: "Entrez le titre de l'étape",
		},
		pricing: {
			label: "Tarification",
			placeholder: "Choisissez une méthode",
			options: {
				sum: {
					label: "Supplémentaire",
					tooltip: "Chaque élément ajouté sera incrémenté dans la valeur du produit",
				},
				average: {
					label: "Moyenne",
					tooltip: "La moyenne des éléments sélectionnés sera incrémentée",
				},
				higher: {
					label: "Valeur la plus élevée",
					tooltip:
						"La valeur la plus élevée parmi les éléments sera ajoutée à la valeur du produit",
				},
			},
		},
		min: {
			label: "Qté min sélectionnable de l'étape",
			tooltip: "Minimum d'articles à sélectionner dans cette étape",
		},
		max: {
			label: "Qté max sélectionnable de l'étape",
			tooltip: "Maximum d'articles à sélectionner dans cette étape",
		},
	},
	fiscalSplit: {
		switchLabel: "Division fiscale",
		enabled: "Division fiscale activée",
		disabled: "Division fiscale désactivée",
		title: "DIVISION FISCALE",
		fiscalWeight: {
			label: "% Poids fiscal de l'étape {{stepNumber}}",
			placeholder: "00%",
			info: "Le poids (%) détermine la part de cette étape sur la facture.",
			supplyAlert: {
				title: "Il y a des approvisionnements dans cette étape",
				message:
					"Lorsque l'étape contient des produits et des approvisionnements, le poids fiscal (%) définit uniquement la part des produits avec des données fiscales sur la facture. Les approvisionnements ci-dessus n'ont pas de données fiscales et ne seront pas émis.",
			},
		},
		summary: {
			title: "Résumé fiscal",
			stepPrefix: "Étape",
			incomplete: "répartissez 100% entre les étapes",
		},
		dialog: {
			triggerLabel: "En savoir plus sur la division fiscale",
			title: "Division fiscale",
			paragraph1:
				"La division fiscale définit comment la valeur totale de la facture est répartie entre les éléments du produit montable.",
			paragraph2: {
				intro:
					"Les poids (%) des étapes déterminent la part des produits avec des données fiscales sur la facture.",
				bold:
					"Les approvisionnements n'ont pas de données fiscales et ne seront pas émis sur la facture finale.",
			},
			example: {
				title: "Exemple :",
				intro: "Une caipirinha de R$ 20 :",
				item1: "Base (70 %) — cachaça (produit avec données fiscales) : R$ 14",
				item2:
					"Compléments (30 %) — sucre (approvisionnement) et citron vert (approvisionnement) : non émis",
				conclusion:
					"Dans ce cas, seule la cachaça participe à la division de la valeur de la facture.",
			},
			close: "Fermer",
			confirm: "Compris",
		},
	},
	itemsSection: {
		title: "ARTICLES SUPPLÉMENTAIRES",
		addItem: "Ajouter un autre article",
		removeItem: "Supprimer l'article",
		fields: {
			item: {
				label: "Article",
				placeholder: "Sélectionnez un article",
				loadingPlaceholder: "Chargement des produits...",
			},
			price: {
				label: "Prix",
			},
			maxCount: {
				label: "Qté max de l'article",
				placeholder: "0",
				tooltip:
					"Nombre maximum de fois que cet article peut être sélectionné dans l'étape",
			},
			storageCount: {
				label: "Qté déduite de l'article",
				placeholder: "0",
				tooltip: "Quantité à déduire du stock par unité",
			},
			isModification: {
				label: "Article de modification",
			},
		},
	},
};
